import { config } from '../config';
import { useHref, useLang } from '../lang';
import { PATHS, type Route } from '../routes';
import { FOOTER_NAV, LangSwitch } from './Header';

export function Footer({ route }: { route: Route }) {
  const { t } = useLang();
  const href = useHref();
  return (
    <footer className="footer">
      <div className="frame">
        <div className="footer-top">
          <nav aria-label={t('nav.footer')} className="footer-nav">
            {FOOTER_NAV.map(([r, key]) => (
              <a key={r} href={href(PATHS[r])} aria-current={route === r ? 'page' : undefined}>
                {t(key)}
              </a>
            ))}
          </nav>
          <div className="footer-end">
            <LangSwitch route={route} tone="paper" />
            {route !== 'demo' && (
              <a className="btn btn-primary btn-sm" href={href(PATHS.demo)}>
                {t('nav.cta')}
              </a>
            )}
          </div>
        </div>
        <p className="footer-word" translate="no" aria-hidden="true">
          IRIS
          <span className="footer-dot" />
        </p>
        <div className="footer-contact">
          <p>
            <span className="mono">{t('foot.sales')}</span>{' '}
            <a href={`mailto:${config.salesEmail}`} dir="ltr">
              {config.salesEmail}
            </a>
          </p>
          <p>{t('foot.place')}</p>
        </div>
        <div className="footer-base mono">
          <span translate="no">© {new Date().getFullYear()} IRIS</span>
          <span>{t('foot.partner')}</span>
          <a href="#top">{t('foot.top')}</a>
        </div>
      </div>
    </footer>
  );
}
